import { h, Fragment } from 'preact'
import { useState } from 'preact/hooks'

import CustomCenterSpinner from './CustomCenterSpinner'
import * as style from '../custom-booked-page/style.css'

interface Props {
    customRedirectUrl: string
}

const CustomBookedPage: preact.FunctionalComponent<Props> = ({ customRedirectUrl }) => {
    const [showSpinner, setShowSpinner] = useState(true)

    return (
        <Fragment>
            <section class={style.booked}>
                {showSpinner && <CustomCenterSpinner />}
                <iframe src={`${customRedirectUrl}`} class={style.bookedIframe} onLoad={() => setShowSpinner(false)} />
            </section>
        </Fragment>
    )
}

export default CustomBookedPage
